import ReactPlayer from "react-player"
import { CustomChart } from "../../../components/Chart/Chart";
import { HeaderSidebar } from "../../../components/Header/HeaderSidebar";
import { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { StepperButtons } from "../../../components/Stepper/Buttons";
import { setProgress } from "../../../store/progressSlice";
import { ProgressLine } from "../../../components/Progress/Line";
import { getCompetitionForm } from "../../../services/autofillService";
import { AddMore } from "../../../components/Buttons/AddMoreButton";
import { questions, videos } from "../../../content/relationships/competition";
import { submitCompetition } from "../../../services/answersService";

export const RelationshipsCompetition = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const chartRef = useRef(null);
  const fieldRefs = useRef([]);
  const [showExplanation, setShowExplanation] = useState(true);
  const [competitionForm, setCompetitionForm] = useState({
    attributes: [],
    labels: ["Your Company Now", "Your Aim"],
    datasets: [
      {
        backgroundColor: ["white", "#FCE816"],
        borderColor: ["white", "transparent"],
        data: [
          {
            x: 3,
            y: 0,
          },
          {
            x: 4,
            y: 5,
          },
        ],
      },
    ],
  })

  const [isLoading, setIsLoading] = useState(false);

  function validateLabels(value) {
    let error;
    if (!value) {
      error = 'Please fill this field.';
    }
    return error;
  }

  const _handleSubmit = (values) => {
    setIsLoading(true);
    // Maybe does not have to be an array
    submitCompetition(
      [
        {
          attributes: values.attributes,
          labels: values.labels,
          positions: values.datasets[0].data
        }
      ]
    ).then(response => {
      setIsLoading(false);
      navigate("/flow/relationships/trends");
    }).catch(err => {
      setIsLoading(false);
      console.error(err);
    })
  };

  const updateChart = (e, validateField, values) => {
    if (e.key === 'Enter') {
      const labelCount = values.labels.length;
      const dataCount = values.datasets[0].data.length;

      if (labelCount <= dataCount) return;

      validateField(`labels.${values.labels.length - 1}`).then(response => {
        // If no error update
        if (response === undefined) {
          setCompetitionForm({
            attributes: values.attributes,
            labels: values.labels,
            datasets: [
              {
                backgroundColor: [...values.datasets[0].backgroundColor, "transparent"],
                borderColor: [...values.datasets[0].borderColor, "white"],
                data: [...values.datasets[0].data, { x: -1, y: -1 }]
              }
            ]
          });
        }
      }).catch(err => {
        console.error(err);
      });
    }
  }

  const handleDoubleClick = (e) => {
    const pos = chartRef.current.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true)
    const idx = pos[0].index;
    fieldRefs.current.forEach(fieldRef => {
      fieldRef.classList.add("hidden")
    });
    fieldRefs.current.at(idx).classList.remove("hidden")
    fieldRefs.current.at(idx).classList.add("w-max", "has-border-bottom")
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }

  const handleClick = (push, validateField, values) => {
    console.log("clicked");
    console.log(values.labels.length);
    push();
    const labelCount = values.labels.length;
    const dataCount = values.datasets[0].data.length;

    if (labelCount <= dataCount) return;

    validateField(`labels.${values.labels.length - 1}`).then(response => {
      // If no error update
      if (response === undefined) {
        setCompetitionForm({
          attributes: values.attributes,
          labels: values.labels,
          datasets: [
            {
              backgroundColor: [...values.datasets[0].backgroundColor, "transparent"],
              borderColor: [...values.datasets[0].borderColor, "white"],
              data: [...values.datasets[0].data, { x: -1, y: -1 }]
            }
          ]
        });
      }
    }).catch(err => {
      console.error(err);
    });
  }

  useEffect(() => {
    dispatch(setProgress(93));
    getCompetitionForm().then(response => {
      if (response) {
        const competition = response.data[0];
        const len = (competition.positions.length || competition.labels.length) - 2;
        setCompetitionForm({
          attributes: competition.attributes,
          labels: competition.labels,
          datasets: [
            {
              backgroundColor: ["white", "#FCE816", ...Array(len)].fill("transparent", 2),
              borderColor: ["white", "transparent", ...Array(len)].fill("white", 2),
              data: [...competition.positions]
            }
          ]
        })
      }
    }).catch(err => {
      console.error(err);
    })
  }, []);

  return (
    <>
      <ProgressLine />
      <button
        className="w-[12rem] bg-white text-black p-4 absolute top-0 left-[50%] translate-x-[-50%]"
        onClick={() => setShowExplanation(!showExplanation)}>
        {showExplanation ? "Hide Explanation" : "Show Explanation"}
      </button>
      <main className="relationships has-black-bg container">
        <Formik
          initialValues={competitionForm}
          onSubmit={_handleSubmit}
          enableReinitialize
        >
          {({ values, errors, validateField }) => (
            <Form className="relative flex flex-col w-full" onKeyDown={handleKeyDown}>
              {showExplanation && (
                <article className="max-w-[50%] m-auto pb-24">
                  <div className="max-w-96">
                    <ReactPlayer
                      url={videos.competitionVideo.url}
                      controls
                      className='react-player'
                      width="100%"
                      height="100%"
                    />
                  </div>
                  <section className="relative w-full">
                    <span className="absolute -left-8 text-sm text-light-grey top-1">
                      {questions.competition.number}
                    </span>
                    <div className="flex flex-col gap-3 max-h-96 overflow-y-scroll">
                      <h3 className="text-2xl text-light-grey">{questions.competition.question}</h3>
                      <p className="text-light-grey text-sm">{questions.competition.description}</p>
                    </div>
                  </section>
                </article>
              )}
              {/* <StepOne values={values} isActive={activeStep === 0} /> */}
              <section className="flex self-end">
                <FieldArray name="labels">
                  {({ insert, remove, push }) => (
                    <>
                      {values.labels.length > 0 && values.labels.slice(0, values.labels.length).map((_, index) => (
                        <Field
                          key={index}
                          name={`labels.${index}`}
                          placeholder={`Competitor Name ${values.labels.length}`}
                          className={values.labels.length - 1 <= index ? "w-max has-border-bottom" : "hidden"}
                          validate={validateLabels}
                          style={errors.labels ? { borderBottom: "2px solid red" } : {}}
                          innerRef={(el) => (fieldRefs.current[index] = el)}
                          onKeyDown={(e) => updateChart(e, validateField, values)}
                        />
                      ))
                      }
                      <AddMore onClick={() => handleClick(push, validateField, values)} style={{ position: "relative", marginRight: "120px" }} />
                    </>
                  )}
                </FieldArray>
              </section>
              <FieldArray name="attributes">
                <div className="flex flex-col items-center justify-center">
                  <fieldset>
                    <Field
                      name={`attributes.${1}`}
                      className="has-border-bottom"
                      placeholder="Value 2"
                    />
                  </fieldset>
                  <fieldset className="flex gap-5 items-center w-full">
                    <Field
                      className="has-border-bottom"
                      name={`attributes.${0}`}
                      placeholder="Value 1"
                    />
                    <CustomChart
                      ref={chartRef}
                      data={competitionForm}
                      handleDoubleClick={(e) => handleDoubleClick(e)} />
                    <Field
                      className="has-border-bottom"
                      name={`attributes.${2}`}
                      placeholder="Value 3"
                    />
                  </fieldset>
                  <fieldset>
                    <Field
                      className="has-border-bottom"
                      name={`attributes.${3}`}
                      placeholder="Value 4"
                    />
                  </fieldset>
                </div>
              </FieldArray>
              <StepperButtons
                link="/flow/personality/attributes"
                isLoading={isLoading}
                showNext
              />
            </Form>
          )}
        </Formik>
      </main>
      <HeaderSidebar activeEl="Relationships" />
    </>
  );
};
